/* eslint-disable */
import React, { Component } from 'react';
import Intercom from 'react-intercom';
import { browserHistory } from 'react-router';
import App_data from '../../views/config/App_data';
import FD from '../../views/RestAPI/fetchData';
import { getActiveExams } from '../../common/constant';
// import ReactAdroll from "react-adroll";

const mobx = require('mobx');
const autorun = mobx.autorun;
import UserStore from '../../store/userStore';

/* eslint-disable*/
class IntercomWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      /* token : this.props.location.state.token,   //Authentication Token
      idname : this.props.location.state.idname,  //Email Id*/
      token: '',
      idname: '',
      avatar: '',
      email: '',
      username: '',
      exam: '',
      exam_package: '',
    };
    // ReactAdroll.init("WBMVWJ6ZUREQVFVU46D277", "BAW72YICJBBLDPI7366YAG");
  }

  componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (!storage_session) {
      browserHistory.push('/');
    } else {
      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
      this.setState({ idname: storage_session['idname'] });
      this.setState({ token: storage_session['token'] });
      //console.log('---------'+storage_session['idname']);
      var data = {
        token: storage_session['token'],
        idname: storage_session['idname'],
      };

      this.dispose = autorun(() => {
        if(UserStore.profileInfo == null) return;
        const { email, username, exam, exam_package, imageUrl } = UserStore.profileInfo;
        this.setState({
          email,
          username,
          exam: getActiveExams(exam) || exam,
          exam_package,
        });
      })

      // FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, data).then(resp => {
      //   console.log("-----------------------++++++ProfileInfo:: ")
      //   if (resp.success) {
      //     const { email, username, exam, exam_package, imageUrl } = resp.profileInfo;
      //     this.setState({
      //       email,
      //       username,
      //       exam: getActiveExams(exam) || exam,
      //       exam_package,
      //     });
      //
      //     if (imageUrl === null || imageUrl === '')
      //       this.setState({
      //         avatar: `${App_data.frontend_url}/img/avatars/defaultProfileImage.jpg`,
      //       });
      //     else this.setState({ avatar: imageUrl });
      //   } else {
      //     this.setState({
      //       avatar: `${App_data.frontend_url}/img/avatars/defaultProfileImage.jpg`,
      //     });
      //   }
      //   return resp;
      // });
    }
  }

  render() {
    const appUser = this.state;
    const user = {
      email: appUser.email,
      name: appUser.username,
      Exam: appUser.exam,
      Exam_package: appUser.exam_package,
      Premium: appUser.exam_package ? true : false,
    };
    if (window.location.href.indexOf('/cart') !== -1) {
      user.Cart = true;
    }
    // if (window.location.href.indexOf("/thankyou") !== -1) {
    //   user.Premium = true;
    // }
    return (
      <div>
        <Intercom appID='k16xdlc8' {...user} />
      </div>
    );
  }
}

export default IntercomWidget;



// WEBPACK FOOTER //
// ./src/components/IntercomWidget/IntercomWidget.js